// Sorting criteria enum for ListSection component
export const SortCriteria = {
    // Number sorting
    NUMBER_ASC: 'NUMBER_ASC',
    NUMBER_DESC: 'NUMBER_DESC',

    // Alphabetic sorting
    ALPHABETIC_ASC: 'ALPHABETIC_ASC',
    ALPHABETIC_DESC: 'ALPHABETIC_DESC',

    // Date sorting
    DATE_ASC: 'DATE_ASC',
    DATE_DESC: 'DATE_DESC',

    // Boolean sorting
    BOOLEAN_ASC: 'BOOLEAN_ASC',
    BOOLEAN_DESC: 'BOOLEAN_DESC',
}

// Helper function to get sort direction label
export const getSortDirectionLabel = (criteria) => {
    if (!criteria) return null

    if (criteria.includes('_ASC')) {
        return 'ASC'
    } else if (criteria.includes('_DESC')) {
        return 'DESC'
    }
    return null
}

// Helper function to toggle sort direction
export const toggleSortDirection = (criteria) => {
    if (!criteria) return null

    if (criteria.includes('_ASC')) {
        return criteria.replace('_ASC', '_DESC')
    } else if (criteria.includes('_DESC')) {
        return criteria.replace('_DESC', '_ASC')
    }
    return criteria
}

// Helper function to get next sort criteria for a column type
export const getNextSortCriteria = (currentCriteria, columnType) => {
    if (!currentCriteria) {
        // Default to ascending for the column type
        switch (columnType) {
            case 'numeric':
                return SortCriteria.NUMBER_ASC
            case 'date':
                return SortCriteria.DATE_ASC
            case 'text':
            case 'link':
                return SortCriteria.ALPHABETIC_ASC
            case 'boolean':
                return SortCriteria.BOOLEAN_ASC
            default:
                return SortCriteria.ALPHABETIC_ASC
        }
    }

    // Toggle direction
    return toggleSortDirection(currentCriteria)
}
